/**
 * Nurse App Data Models
 * Data models for Nurse & Assistant Nurse Management App
 */

// Mascot Levels
export const MASCOT_LEVELS = {
  1: {
    id: 'NOVICE',
    name: 'Novice',
    nameThai: 'มือใหม่',
    minXP: 0,
    maxXP: 500,
    description: 'เริ่มต้นการเดินทางของคุณ'
  },
  2: {
    id: 'EXPERIENCED',
    name: 'Experienced',
    nameThai: 'มีประสบการณ์',
    minXP: 501,
    maxXP: 1500,
    description: 'คุณมีประสบการณ์แล้ว'
  },
  3: {
    id: 'SENIOR',
    name: 'Senior',
    nameThai: 'อาวุโส',
    minXP: 1501,
    maxXP: 3000,
    description: 'คุณเป็นพยาบาลอาวุโส'
  },
  4: {
    id: 'EXPERT',
    name: 'Expert',
    nameThai: 'ผู้เชี่ยวชาญ',
    minXP: 3001,
    maxXP: 5000,
    description: 'คุณเป็นผู้เชี่ยวชาญ'
  },
  5: {
    id: 'NURSEAPP_QUEEN',
    name: 'NurseApp Queen',
    nameThai: 'ราชินีการดูแล',
    minXP: 5001,
    maxXP: Infinity,
    description: 'คุณคือราชินีการดูแล'
  }
};

// Get mascot by XP
export const getMascotByXP = (xp) => {
  for (let level = 5; level >= 1; level--) {
    const mascot = MASCOT_LEVELS[level];
    if (xp >= mascot.minXP) {
      return {
        level: level,
        mascotId: mascot.id,
        name: mascot.name,
        nameThai: mascot.nameThai,
        xp: xp,
        xpToNext: mascot.maxXP === Infinity ? null : mascot.maxXP,
        progressPercent: mascot.maxXP === Infinity ? 100 : 
          ((xp - mascot.minXP) / (mascot.maxXP - mascot.minXP)) * 100
      };
    }
  }
  return null;
};

// Equipment Types
export const EQUIPMENT_TYPES = {
  SMALL_ITEM: 'SMALL_ITEM',
  LARGE_ITEM: 'LARGE_ITEM'
};

// Equipment Status
export const EQUIPMENT_STATUS = {
  PENDING_APPROVAL: 'PENDING_APPROVAL', // รออนุมัติ (เมื่อสร้างใหม่หรือแก้ไข)
  AVAILABLE: 'AVAILABLE', // ว่างพร้อมใช้งาน (วางอยู่ในตำแหน่งที่เก็บ)
  IN_USE: 'IN_USE', // กำลังใช้งานอยู่ (ใช้ภายในทีม - คนไข้ใช้อยู่)
  BORROWED: 'BORROWED', // ถูกยืม (ยืม-คืนจากคนภายนอกทีม)
  MAINTENANCE: 'MAINTENANCE',
  REPAIR: 'REPAIR',
  UNAVAILABLE: 'UNAVAILABLE',
  DAMAGED: 'DAMAGED',
  LOST: 'LOST',
  REJECTED: 'REJECTED' // ถูกปฏิเสธ (เมื่อ Leader reject)
};

// Inspection Rounds
export const INSPECTION_ROUNDS = {
  MORNING_BEFORE: 'MORNING_BEFORE',
  MORNING_AFTER: 'MORNING_AFTER',
  AFTERNOON_BEFORE: 'AFTERNOON_BEFORE',
  AFTERNOON_AFTER: 'AFTERNOON_AFTER',
  NIGHT_BEFORE: 'NIGHT_BEFORE',
  NIGHT_AFTER: 'NIGHT_AFTER'
};

// Team Types
export const TEAM_TYPES = {
  DEPARTMENT: 'DEPARTMENT',
  GOVERNMENT_HOSPITAL: 'GOVERNMENT_HOSPITAL',
  PRIVATE_HOSPITAL: 'PRIVATE_HOSPITAL',
  CLINIC: 'CLINIC',
  HOME_CARE: 'HOME_CARE',
  NURSING_HOME: 'NURSING_HOME',
  COMMUNITY_HEALTH: 'COMMUNITY_HEALTH',
  OTHER: 'OTHER'
};

// Team Type Labels (Thai)
export const TEAM_TYPE_LABELS = {
  [TEAM_TYPES.DEPARTMENT]: 'แผนก',
  [TEAM_TYPES.GOVERNMENT_HOSPITAL]: 'โรงพยาบาลรัฐบาล',
  [TEAM_TYPES.PRIVATE_HOSPITAL]: 'โรงพยาบาลเอกชน',
  [TEAM_TYPES.CLINIC]: 'คลีนิค',
  [TEAM_TYPES.HOME_CARE]: 'ทีมเฝ้าไข้ตามบ้าน',
  [TEAM_TYPES.NURSING_HOME]: 'สถานพยาบาล/บ้านพักผู้สูงอายุ',
  [TEAM_TYPES.COMMUNITY_HEALTH]: 'สถานีอนามัย/ศูนย์สุขภาพชุมชน',
  [TEAM_TYPES.OTHER]: 'อื่นๆ'
};

// Team Roles
export const TEAM_ROLES = {
  LEADER: 'LEADER',
  DEPUTY_LEADER: 'DEPUTY_LEADER',
  MEMBER: 'MEMBER'
};

// Job Roles
export const JOB_ROLES = {
  DOCTOR: 'DOCTOR',
  NURSE: 'NURSE',
  ASSISTANT_NURSE: 'ASSISTANT_NURSE',
  STAFF: 'STAFF',
  ADMIN: 'ADMIN'
};

// Shift Types
export const SHIFT_TYPES = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  NIGHT: 'NIGHT'
};

// Shift Status
export const SHIFT_STATUS = {
  SCHEDULED: 'SCHEDULED',
  CONFIRMED: 'CONFIRMED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

// Package Types
export const PACKAGE_TYPES = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  ENTERPRISE: 'ENTERPRISE'
};

// Feature Names
export const FEATURE_NAMES = {
  SHIFT_MANAGEMENT: 'shiftManagement',
  EQUIPMENT_MANAGEMENT: 'equipmentManagement',
  TEAM_MANAGEMENT: 'teamManagement',
  GAMIFICATION: 'gamification',
  MARKETPLACE: 'marketplace',
  GIFT_SYSTEM: 'giftSystem',
  MASCOT_RANKING: 'mascotRanking'
};


